import React from "react";
import { useNavigate } from "react-router-dom";
import AdventureMap from "../components/games/AdventureMap";

const GamesPage = () => {
  const navigate = useNavigate();

  return (
    <div
      className="w-full"
      style={{
        minHeight: "100dvh",
        background: "linear-gradient(180deg, #BFE6FF 0%, #DFF3E4 55%, #FBF3D6 100%)",
      }}
    >
      <AdventureMap onSelect={(id) => navigate(`/games/${id}`)} />
    </div>
  );
};

export default GamesPage;
